import Cookies from 'universal-cookie';

/** Set when we send the user to OC /account from a user-profile trampoline. */
export const AUTH_PORTAL_ACCOUNT_VISIT_KEY = 'insightAuthPortalAccountVisit';

export function markAuthPortalAccountVisit(storage = sessionStorage) {
  try {
    storage.setItem(AUTH_PORTAL_ACCOUNT_VISIT_KEY, '1');
  } catch {
    // Private mode / quota.
  }
}

/**
 * True when the user is returning to a trampoline after we sent them to OC /account
 * (e.g. credential-change logout). Clears the flag when consumed.
 */
export function consumeAuthPortalAccountVisit(storage = sessionStorage) {
  try {
    const pending = storage.getItem(AUTH_PORTAL_ACCOUNT_VISIT_KEY) === '1';
    if (pending) {
      storage.removeItem(AUTH_PORTAL_ACCOUNT_VISIT_KEY);
    }
    return pending;
  } catch {
    return false;
  }
}

/**
 * Insight `_Id` / accountId cookies can survive OC credential-change logout.
 * Clear them so AuthGuard and CamSDK do not treat the session as still active.
 */
export function clearStaleInsightSessionMarkers(cookieJar = new Cookies()) {
  const secure = process.env.secureCoockie;
  const pathOpts = { path: '/', secure };
  const scoped = [{ path: '/' }, { domain: '.netgear.com' }, { path: '/', domain: '.netgear.com' }];
  const names = ['_Id', 'accountId', 'userAccountId', 'token', 'sessionActive', 'redirectCookies'];
  for (const name of names) {
    cookieJar.remove(name);
    cookieJar.remove(name, pathOpts);
    for (const opts of scoped) {
      cookieJar.remove(name, opts);
    }
  }
}
